import React, { useEffect, useState } from "react";
import moment from "moment";
import Mixpanel from "mixpanel-browser";

import ReactTable from "../../common/react-table/ReactTable";
import ActionImg from "../../assets/images/action.svg";
import trashImg from "../../assets/images/trash.svg";
import edit from "../../assets/images/edit.svg";
import { useDispatch, useSelector } from "react-redux";
import { getProjectList } from "../../features/projectManagement/getProjectListSlice";
import EditProjectModal from "./modal/EditProjectModal";
import ConfirmationModal from "../../common/modal/ConfirmationModal";
import { deleteProject } from "../../features/projectManagement/deleteProjectSlice";
import { OK } from "../../constants/statusCode";
import { /* showSuccess, */ showWarning } from "../../utils/messageHelper";
import Input from "../form-components/Input";
import { RoleRightsForModule } from "../../utils/utils";
import { getSwitchProjectList } from "../../features/projectManagement/switchProjectSlice";
import AddProjectModal from "./modal/AddProjectModal";

const ManageProjects = ({
  currentModal,
  setCurrentModal = () => {},
  toggleFunction = () => {},
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [deleteId, setDeleteId] = useState("");
  const [editId, setEditId] = useState("");
  const [isDefaultStatus, setIsDefaultStatus] = useState("");

  const { total_records, projectList } = useSelector((state) => ({
    total_records:
      state?.getProjectListReducer?.responseData?.pagination?.total_records,
    projectList: state?.getProjectListReducer?.responseData?.projects,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjectList({ perPage: perPage, page: currentPage }));
  }, [perPage, currentPage]);

  const handleTotalPage = (page) => {
    setPerPage(Number(page));
    setCurrentPage(1);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(Number(page));
  };

  const onDeleteProject = async () => {
    Mixpanel.track("Delete project Button Clicked", {
      Page: "Delete Project Modal",
    });
    if (isDefaultStatus !== 1) {
      const { payload } = await dispatch(deleteProject(deleteId));
      if (payload.status === OK) {
        dispatch(getProjectList({ perPage: perPage, page: currentPage }));
        dispatch(getSwitchProjectList({ search: "" }));
        toggleFunction();
        // showSuccess(payload?.data?.responseMessage);
        setDeleteId("");
      }
    } else {
      showWarning("You can not delete default project");
      setCurrentModal("");
    }
  };

  const userId = JSON.parse(localStorage.getItem("_user"))["projects"][0][
    "uuid"
  ];

  const columns = [
    {
      Header: "Project Short Name",
      accessor: (data) => (
        <div className="d-flex">
          <div className="form-check text-start footer-check">
            {data?.Users[0].ProjectUser?.is_default === 1 && (
              <Input
                disabled={true}
                checked={true}
                className="form-check-input"
                type="checkbox"
                id={"is_default_" + data.uuid}
              />
            )}
          </div>
          <p className="doc-name">{data?.name}</p>
        </div>
      ),
    },
    {
      Header: "Organisation",
      accessor: (data) => (
        <div className="d-flex">
          <p className="doc-name">{data?.Organizations[0]?.name}</p>
        </div>
      ),
    },
    {
      Header: "Website URL",
      accessor: (data) => (
        <p className="doc-name">
          {data?.website_url ? data?.website_url : "-"}
        </p>
      ),
    },
    {
      Header: "Created Date",
      accessor: (data) => (
        <p className="doc-name">
          {moment(data?.created_at).format("MMM DD, YYYY")}
        </p>
      ),
    },
    {
      Header: "Action",
      disableSortBy: true,
      accessor: (data) => (
        <div className="dropdown action-dropdown">
          {(RoleRightsForModule("Update", "Manage Projects") ||
            RoleRightsForModule("Delete", "Manage Projects")) && (
            <button
              className="btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={ActionImg} alt="" />
            </button>
          )}
          <ul className="dropdown-menu">
            {RoleRightsForModule("Update", "Manage Projects") && (
              <li
                className="dropdown-item mt-1"
                onClick={() => {
                  setCurrentModal("editProjectModal");
                  setEditId(data?.uuid);
                }}
              >
                <span>
                  <img src={edit} className="user-table-drow-img" alt="" />
                </span>
                Edit
              </li>
            )}
            {RoleRightsForModule("Delete", "Manage Projects") &&
              userId &&
              JSON.parse(localStorage.getItem("_user"))["projects"][0][
                "uuid"
              ] !== data?.uuid && (
                <li
                  className="dropdown-item mt-1 delete-btn"
                  onClick={() => {
                    setCurrentModal("deleteProjectModal");
                    setDeleteId(data?.uuid);
                    setIsDefaultStatus(data?.is_default);
                  }}
                >
                  <span>
                    <img
                      src={trashImg}
                      className="user-table-drow-img"
                      alt=""
                    />
                  </span>
                  Delete
                </li>
              )}
          </ul>
        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        <div>
          <ReactTable
            columns={columns}
            data={projectList?.length > 0 ? projectList : []}
            currentPage={currentPage}
            perPage={perPage}
            totalCount={total_records}
            handlePerPage={handleTotalPage}
            onPageChange={(page) => {
              handleCurrentPage(page);
            }}
          />
        </div>
      </div>
      {currentModal === "addProjectModal" && (
        <AddProjectModal
          isVisible={currentModal === "addProjectModal"}
          toggleFunction={toggleFunction}
        />
      )}
      {currentModal === "editProjectModal" && (
        <EditProjectModal
          isVisible={currentModal === "editProjectModal"}
          toggleFunction={toggleFunction}
          projectId={editId}
        />
      )}
      {currentModal === "deleteProjectModal" && (
        <ConfirmationModal
          title={"Delete project"}
          isOpen={currentModal === "deleteProjectModal"}
          toggle={toggleFunction}
          onConfirm={onDeleteProject}
          message="Are you sure you want to delete this project?"
        />
      )}
    </>
  );
};

export default ManageProjects;
